import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "text", "tag", "inline", "autoBlankExternalLinks", "onLinkClick", "rendererProps"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { createUseStyles } from 'react-jss';
import MarkdownIt from 'markdown-it';
import withMemo from '../../decorators/withMemo';
import { useSafeCall } from '../../helpers/React';
import { configure, fixSpaces } from './utils';
import styles from './styles';
var useStyles = createUseStyles(styles);
var MarkdownText = function MarkdownText(props) {
  var classes = useStyles(props);
  var className = props.className,
    text = props.text,
    tag = props.tag,
    inline = props.inline,
    autoBlankExternalLinks = props.autoBlankExternalLinks,
    onLinkClick = props.onLinkClick,
    rendererProps = props.rendererProps,
    otherProps = _objectWithoutProperties(props, _excluded);
  var md = useMemo(function () {
    return configure(new MarkdownIt(_objectSpread({
      breaks: true,
      html: true
    }, rendererProps)), {
      autoBlankExternalLinks: autoBlankExternalLinks
    });
  }, [rendererProps, autoBlankExternalLinks]);
  var correctedText = useMemo(function () {
    return fixSpaces(text);
  }, [text]);
  var html = inline ? md.renderInline(correctedText) : md.render(correctedText);
  var Tag = tag || 'div';
  var ref = useRef(null);
  var handleClick = useSafeCall(onLinkClick);
  useEffect(function () {
    if (ref.current) {
      Array.from(ref.current.querySelectorAll('a')).forEach(function (m) {
        // eslint-disable-next-line no-param-reassign
        m.onclick = handleClick;
      });
    }
  }, [ref, html, handleClick]);
  return /*#__PURE__*/React.createElement(Tag, _extends({}, otherProps, {
    ref: ref,
    className: cx(inline !== true && classes.container, className),
    dangerouslySetInnerHTML: {
      __html: html
    }
  }));
};
MarkdownText.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  tag: PropTypes.elementType,
  inline: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  rendererProps: PropTypes.object,
  autoBlankExternalLinks: PropTypes.bool,
  onLinkClick: PropTypes.func
};
MarkdownText.defaultProps = {
  className: null,
  text: '',
  tag: 'div',
  inline: false,
  rendererProps: null,
  autoBlankExternalLinks: true,
  onLinkClick: function onLinkClick() {
    return null;
  }
};
export default withMemo()(MarkdownText);